import './tag-select/tag-select.component';
import './tag-select/tag-select.scss';

import './tags-chips-autocomplete/tags-chips-autocomplete.component';
import './tags-chips-autocomplete/tags-chips-autocomplete.scss';

import './tags-display-list/tags-display-list.component';
import './tags-display-list/tags-display-list.scss';

import './tags-multi-select/tags-multi-select.component';
import './tags-multi-select/tags-multi-select.scss';

import './tags-multi-select-list/tags-multi-select-list.component';
import './tags-multi-select-list/tags-multi-select-list.scss';

import './tags-view/tags-view.component';
import './tags-view/tags-view.scss';

import './tags-table/tags-table.component';
import './tags-table/tags-table.scss';

import './tags-table-row/tags-table-row.component';
import './tags-table-row/tags-table-row.scss';
